export default "__VITE_ASSET__2a100274__"